import { render, staticRenderFns } from "./AppEdtiva.vue?vue&type=template&id=e5301552&"
import script from "./AppEdtiva.vue?vue&type=script&lang=js&"
export * from "./AppEdtiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports